import { style } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

export const tileTitle = style({
  margin: `0 0 ${primitiveTokens.sizing["2x"]}`,
  fontSize: primitiveTokens.type.xs,
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  opacity: 0.6
});

export const tile = style({
  padding: primitiveTokens.sizing["3x"],
  borderRadius: primitiveTokens.radii.md,
  background: semanticThemeTokens.tile.backgroundColor,
  border: `${primitiveTokens.borderWidth.default} solid ${semanticThemeTokens.tile.borderColor}`,
  height: "100%"
});
